import React from "react";

type Props = {
  className?: string;
};

export function WhatsAppIcon({ className = "h-5 w-5" }: Props) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path
        fill="#25D366"
        d="M16.01 2.02c-7.73 0-14 6.27-14 14 0 2.73.79 5.27 2.16 7.42L2 30l6.73-2.08a13.93 13.93 0 007.28 2.08h.01c7.73 0 14-6.27 14-14s-6.27-14-14-14z"
      />
      <path
        fill="#FFF"
        d="M23.54 19.44c-.4-.2-2.36-1.16-2.72-1.29-.36-.13-.62-.2-.88.2-.26.4-1.01 1.29-1.24 1.55-.23.26-.45.3-.85.1-.4-.2-1.69-.62-3.22-1.98-1.19-1.06-2-2.36-2.23-2.76-.23-.4-.02-.62.18-.82.18-.18.4-.45.6-.68.2-.23.26-.4.4-.66.13-.26.07-.5-.03-.7-.1-.2-.88-2.12-1.2-2.9-.31-.74-.62-.64-.88-.65h-.75c-.26 0-.7.1-1.07.5-.36.4-1.4 1.36-1.4 3.32 0 1.96 1.43 3.86 1.63 4.12.2.26 2.82 4.3 6.84 6.03.96.41 1.7.66 2.28.85.96.3 1.83.26 2.52.16.77-.11 2.36-.96 2.69-1.88.33-.92.33-1.7.23-1.88-.1-.18-.36-.3-.75-.5z"
      />
    </svg>
  );
}
